<form [formGroup]="form">
  <div>
    <label class="col-4">{{''| i18n:'special-request-for'}}</label>
    <label class="col-4">{{''| i18n:'requirements'}}</label>
    <label class="col-4">{{''| i18n:'justification'}}</label>
  </div>
  <div class="row">
    <div class="col-4">
      <select formControlName="specialRequestFields" [multiple]="false" (change)="emit()">
        <option [ngValue]=undefined>{{''|i18n:'select'}}</option>
        @for (specialRequestField of specialRequestFields; track specialRequestField) {
          <option [ngValue]="specialRequestField"
          >{{'' | i18n:specialRequestField.name}}</option>
        }
      </select>
      @if (invalidField('specialRequestFields')) {
        <app-error-field
        [errorMessage]="'special-request-field-is-required'"></app-error-field>
      }
    </div>
    <div class="col-4">
      <textarea formControlName="requirements" (blur)="emit()" (keypress)="emit()" maxlength="500"
      [placeholder]="''| i18n:'requirements'"></textarea>
      @if (invalidField('requirements')) {
        <app-error-field
        [errorMessage]="'requirements-is-required'"></app-error-field>
      }
    </div>
    <div class="col-4">
      <textarea formControlName="justification" (blur)="emit()" (keypress)="emit()" maxlength="500"
      [placeholder]="''|i18n:'justification'"></textarea>
      @if (invalidField('justification')) {
        <app-error-field
        [errorMessage]="'justification-is-required'"></app-error-field>
      }
    </div>

  </div>
</form>
<div class="row">
  <div class="col-4"></div>
  <div class="col-8">
    <div class="row">
      <div class="col-9">
        <div>{{''| i18n:'upload-supporting-material'}}:</div>
        <input type="file"
          (change)="selectSupportingDocument($event?.target?.files)"
          [accept]="allowedFileTypes"
          [formControl]="selectedFileFormControl">
        </div>
        <button class="col-2" [disabled]="!supportingDocument"
        (click)="saveSupportingDocument()">{{''|i18n:'upload'}}</button>
      </div>
    </div>
  </div>
